import React, { useState } from "react";
import { Link } from "react-router-dom";

const AttributeItem = ({ showBtn = true, href, children, values,setOptions,propertyName }) => {
  const [showSubCategory, setShowSubCategory] = useState(false);

  // console.log(values);
  const toggleSubCategory = (event) => {
    event.stopPropagation();
    setShowSubCategory(!showSubCategory);
  };

  const handleChange = (event) => {
    setOptions(prev => {

      const options = { ...prev };
      if (event.target.value === "") {
        delete options[event.target.name];
        return options;
      }
      options[event.target.name] = event.target.value;
      return options;
    });
  }

  return (
    <li className="w-full flex flex-col gap-2">
      <button
        className="flex items-center w-full justify-between gap-12"
        onClick={toggleSubCategory}
      >
        <Link
          to={href}
          className="break-before-all text-left break-words hover:text-orange-400 transition-colors duration-300 ease-in-out"
        >
          {children}
        </Link>
        {showBtn && (
          <i
            onClick={toggleSubCategory}
            className={`fas ${
              showSubCategory ? "fa-angle-down" : "fa-angle-right"
            } shrink-0`}
          ></i>
        )}
      </button>

      {showSubCategory && values?.length > 0 && (
        <select
          name={propertyName}
          onChange={handleChange}
          className="px-12">
          <option value="">Select {propertyName}</option>
          {values?.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </select>
      )}
    </li>
  );
};

export default AttributeItem;
